<template>
  <!-- 商户管理 -->
  <div class="container">
    <div>
      <Form
        @submit.native.prevent
        :model="formData"
        label-position="left"
        class="mytable-titleBox clearfix"
      >
        <RadioGroup
          v-model.trim="formData.activity_type"
          type="button"
          class="fl mr20 mt24"
          @on-change="handleRefundchange"
        >
          <Radio :label="null">全部</Radio>
          <Radio :label="0">未开始</Radio>
          <Radio :label="1">进行中</Radio>
          <Radio :label="2">已结束</Radio>
        </RadioGroup>
        <Button type="primary" @click="handleEdit(null)" class="fr ml24">活动时间设置</Button>
      </Form>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    />
    <Modal
      v-model="modalVisibile"
      width="576"
      :mask-closable="false"
      :title="modalTitle"
      @on-cancel="handleCancel"
    >
      <Form ref="modalForm" :model="modalForm" label-position="top" :rules="ruleValidate">
        <FormItem label="活动标题:" class="mytable-title" prop="title">
          <Input v-model.trim="modalForm.title" style="width: 512px;" placeholder="请输入活动标题"></Input>
        </FormItem>
        <FormItem label="活动内容:" class="mytable-title mt24" prop="activity_content">
          <Input
            v-model.trim="modalForm.activity_content"
            style="width: 512px;"
            type="textarea"
            placeholder="请输入内容"
          ></Input>
        </FormItem>
        <div class="clearfix">
          <FormItem label="活动日期范围:" class="mt24 fl" prop="start_time">
            <Date-picker
              :options="options"
              type="datetimerange"
              placeholder="选择日期和时间"
              class="w240"
              @on-change="handleDateChange"
              v-model="date"
            ></Date-picker>
          </FormItem>
          <FormItem
            label="排序:"
            class="mytable-title fr mt24"
            prop="activity_sort"
            style="width:200px;"
          >
            <Input v-model.trim="modalForm.activity_sort" placeholder="请输入排序"></Input>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit_time">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getCookie } from "../../libs/util";
import mixins from "@/mixins/page";
import * as qiniu from "qiniu-js";
import authorOrder from "@/components/authorOrder";
import { setInterval } from "timers";
export default {
  mixins: [mixins],
  name: "authorManage",
  components: {
    authorOrder,
  },
  data() {
    return {
      page_num: 1,
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      modalTitle: "添加活动",
      date: [],
      isDisabled: true,
      formData: {
        activity_type: null,
      },
      formData1: {
        activity_type: null,
      },
      modalForm: {
        title: "",
        activity_content: "",
        start_time: "",
        activity_sort: "",
      },
      modalForm1: {
        title: "",
        activity_content: "",
        start_time: "",
        activity_sort: "",
      },
      tableLoading: false,
      modalVisibile: false,
      tableData: [],
      modalLoading: false,
      ruleValidate: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        activity_content: [
          { required: true, message: "请输入活动内容", trigger: "blur" },
        ],
        start_time: [
          { required: true, message: "请选择日期范围", trigger: "blur" },
        ],
        activity_sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
        ],
      },
      columns: [
        {
          title: "排序",
          key: "activity_sort",
        },
        {
          title: "活动标题",
          key: "title",
        },
        {
          title: "起始时间",
          key: "start_time",
          width: 280,
        },
        {
          title: "结束时间",
          key: "end_time",
        },
        {
          title: "状态",
          key: "merchant_status",
          render: (h, params) => {
            var cont;

            return h("div", [
              h(
                "span",
                {
                  class: {
                    blue:
                      params.row.activity_type_str === "进行中" ? true : false,
                    yellow:
                      params.row.activity_type_str === "未开始" ? true : false,
                  },
                },
                params.row.activity_type_str
              ),
            ]);
          },
        },
        {
          title: "操作",
          width: 170,
          render: (h, params) => {
            return h("div", [
              params.row.activity_type !== 2 &&
                h(
                  "span",
                  {
                    class: {
                      btn_edit: true,
                    },
                    on: {
                      click: () => this.handleEdit(params),
                    },
                  },
                  "编辑"
                ),
              h(
                "span",
                {
                  class: {
                    btn_del: true,
                  },
                  on: {
                    click: () => this.handleDel(params),
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    handleDel(param) {
      this.$Modal.confirm({
        render: (h) => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true,
                },
              },
              "删除文章"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true,
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      color: "#2E3133",
                    },
                  },
                  "活动 : "
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#5C6166",
                    },
                  },
                  param.row.title
                ),
              ]
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true,
                },
              },
              "确认要删除选中的文章吗?"
            ),
          ]);
        },
        onOk: () => {
          this.$api.delActivity({ id: param.row.id }).then((res) => {
            this.getTableData();
          });
        },
      });
    },
    handleModalSubmit_time() {
      this.$refs.modalForm.validate((valid) => {
        if (valid) {
          this.modalLoading = true;
          this.modalForm.activity_sort = Number(this.modalForm.activity_sort);

          if (this.modalTitle === "添加活动") {
            this.$api.activityAdd({ ...this.modalForm }).then((res) => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.modalVisibile = false;
                this.modalLoading = false;
                this.getTableData();
                this.handleCancel();
              } else {
                this.$Message.error(res.msg);
              }
              this.modalLoading = false;
            });
          } else {
            this.$api.editActivity({ ...this.modalForm }).then((res) => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.modalVisibile = false;
                this.modalLoading = false;
                this.getTableData();
                this.handleCancel();
              } else {
                this.$Message.error(res.msg);
              }
              this.modalLoading = false;
            });
          }
        }
      });
    },
    handleDateChange(val) {
      if (val[0]) {
        this.modalForm.start_time = val[0];
        this.modalForm.end_time = val[1];
      } else {
        this.modalForm.start_time = "";
        this.modalForm.end_time = "";
      }
    },
    handleRefundchange() {
      this.page_num = 1;
      this.getTableData();
    },

    // 获取表格数据
    getTableData() {
      this.tableLoading = true;
      let param = {
        activity_type: this.formData.activity_type,
        page_num: this.page_num,
        page_size: this.page_size,
      };
      this.$api.activityList(param).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.list;
          this.total = res.data.total_row;
          this.tableLoading = false;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    // 弹框取消
    handleCancel() {
      this.$refs.modalForm.resetFields();
      this.modalForm = Object.assign({}, this.modalForm1);
      this.modalVisibile = false;
      this.date = [];
    },
    handleEdit(params) {
      if (params) {
        this.modalTitle = "编辑活动";
        this.$refs.modalForm.resetFields();
        this.modalForm.id = params.row.id;
        this.modalForm.title = params.row.title;
        this.modalForm.activity_content = params.row.activity_content;
        this.modalForm.activity_sort = params.row.activity_sort+'';

        this.date = ["2020-03-04 00:00:00", "2020-03-05 00:00:00"];
        this.date[0] = this.modalForm.start_time = params.row.start_time;
        this.date[1] = this.modalForm.end_time = params.row.end_time;
      } else {
        this.modalTitle = "添加活动";
      }
      this.modalVisibile = true;
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .ivu-form-item {
  margin-bottom: 0;
}

.checkReset:first-child {
  margin-right: 8px;
}

.ivu-modal-footer {
  border-top: none !important;
}

.shadowLine {
  width: 660px;
  height: 1px;
  background: #e9e9e9;
  margin: 24px 0;
}

.wechartBox {
  width: 282px;
  border: 1px solid #dce1e6;
  border-radius: 4px;
  line-height: 32px;
  padding-left: 12px;

  span {
    width: 74px;
    text-align: center;
    border-left: 1px solid #dce1e6;
    cursor: pointer;
  }
}

/deep/ .ivu-upload-drag {
  border: none;
  background: transparent;
}

/deep/ .textarea.ivu-input {
  min-height: 88px;
  height: 88px;
}

.playFont {
  color: #8a9299;
}

.boldTitle {
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

.graybg {
  width: 724px;
  height: 12px;
  background: #f0f3f5;
  position: relative;
  left: -32px;
  margin-bottom: 24px;
  margin-top: 8px;
}

.shadowTitleClick span {
  cursor: pointer;
}

/deep/ .table_pic {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: block;
  cursor: pointer;
}
</style>
